import React, { useEffect,useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Form, Row } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify'; // Import Toastify
import 'react-toastify/dist/ReactToastify.css';
// layout 
import AuthLayout from '../../../layouts/AuthLayout/AuthLayout';

// components 
import { NioButton, NioCard, NioField, NioBrand } from '../../../components';

import BASE_URL from '../../../utils/apiConfig';

export default function Signup() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [referral, setReferral] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      company_name: '',
      full_name: '',
      phone_number: '',
      email: '',
    }
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referralCode = params.get('referral');
    setReferral(referralCode); // Store referral code in state
  }, []);

  const authenticateUser = async () => {
    try {
        const response = await fetch(`${BASE_URL}/api/api_login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: 'api@gmail.com',
                password: '123',
            }),
        });

        const data = await response.json();
        if (response.ok) {
            return data.access_token; // Return token directly
        } else {
            console.error('Authentication failed:', data.message);
            return null;
        }
    } catch (error) {
        console.error('Error during authentication:', error);
        return null;
    }
};

  // Function to submit form data
  const onSubmit = async (formData) => {
    setIsSubmitting(true);
    const token = await authenticateUser();
    if (!token) {
      setIsSubmitting(false); // Enable button if authentication fails
      return; // Stop if authentication fails
    }

    const requestData = { ...formData, referral };

    try {
        const response = await fetch(`${BASE_URL}/api/tenants`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`, // Use token directly
            },
            body: JSON.stringify(requestData),
        });

        const data = await response.json();
        if (response.ok) {
          toast.success('Successfully Sent the Request, ZiloChat Team will Contact You Soon!', { autoClose: 3000 });
          reset();
          setTimeout(() => navigate('/'), 3000); // Navigate after 3 seconds
        } else {
          // toast.error(`Failed: ${data.errors ? data.errors[0] : 'Unknown error'}`, { autoClose: 5000 });
          if (data.errors) {
              const errorMessages = Object.values(data.errors).flat().join(', ');
              toast.error(`Failed: ${errorMessages}`, { autoClose: 5000 });
          } else {
              toast.error(`Failed: ${data.message || 'Unknown error'}`, { autoClose: 5000 });
          }
        } 
    } catch (error) {
      toast.error('An error occurred while creating the request.', { autoClose: 5000 });
      console.error('Error during saving request data:', error);
    } finally {
      setIsSubmitting(false); // Enable button once request completes (success or error)
    }
};

  return (
    <AuthLayout title="Signup">
      <NioCard className="nl-auth-form-card mx-md-9 mx-xl-auto">
        <NioCard.Body className="p-lg-7">
          <div className="text-center pb-5">
            <div className="mb-3">
              <NioBrand />
            </div>
            <h3>Sign Up to Get Started with ZiloChat</h3>
            {/* <p className="fs-7">Already a member? <Link to="/auth/login" className="btn-link text-primary">Login</Link>.</p> */}
          </div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="gy-4">
              <Col xs="12">
                <NioField>
                  <NioField.Label label="Company Name" htmlFor="company_name" />
                  <NioField.Input id="company_name" placeholder="Enter Company Name" errors={errors.company_name} {...register("company_name", {
                    required: "Company Name is Required"
                  })} 
                  isInvalid={!!errors.company_name}
                  />
                  {errors.company_name && 
                    <Form.Control.Feedback type="invalid">{errors?.company_name?.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col>
              <Col xs="12">
                <NioField>
                  <NioField.Label label="Full Name" htmlFor="full_name" />
                  <NioField.Input id="full_name" placeholder="Enter Full Name" errors={errors.full_name} {...register("full_name", {
                    required: "Full Name is Required"
                  })} 
                  isInvalid={!!errors.full_name}
                  />
                  {errors.full_name && 
                    <Form.Control.Feedback type="invalid">{errors?.full_name?.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col>
              <Col xs="12">
                <NioField>
                  <NioField.Label label="Phone No" htmlFor="phone_number" />
                  <NioField.Input required type="number" id="phone_number" placeholder="Enter Phone No" errors={errors.phone_number} {...register("phone_number", {
                    required: "Phone No is required"
                  })} 
                  isInvalid={!!errors.phone_number}
                  />
                  {errors.phone_number && 
                    <Form.Control.Feedback type="invalid">{errors?.phone_number?.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col>
              <Col xs="12">
                <NioField.Label htmlFor="email" label="Email" />
                <NioField>
                  <NioField.Input
                    required
                    id="email"
                    type="email"
                    htmlFor="email"
                    placeholder="Enter your email"
                    {...register("email", {
                      pattern: {
                        value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        message: "Invalid email address"
                      }
                    })}
                    isInvalid={!!errors.email}
                  />
                  {errors.email && 
                    <Form.Control.Feedback type="invalid">{errors?.email?.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col>
              {/* <Col xs="12">
                <NioField.Label htmlFor="password" label="Password" />
                <NioField>
                  <NioField.Input
                    required
                    id="password"
                    type="password"
                    icon="eye-fill after text-primary"
                    placeholder="Enter your password"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters long"
                      },
                      maxLength: {
                        value: 12,
                        message: "Password must not exceed 12 characters"
                      }
                    })}
                    isInvalid={!!errors.password}
                  />
                  {errors.password && 
                    <Form.Control.Feedback type="invalid">{errors?.password?.message}</Form.Control.Feedback>
                  }
                </NioField>
              </Col> */}
              <Col xs="12">
                <div className="form-group">
                  <NioButton                    
                    className="btn-block btn-primary" label={isSubmitting ? "Submitting..." : "Sign Up To Your Account"} disabled={isSubmitting}/>
                </div>
              </Col>
            </Row>
          </Form>
          {/* <div className="pt-4 text-center overflow-hidden">
            <div className="small nl-text-sep">
              <span className="bg-white px-2 text-uppercase">or register with</span>
            </div>
          </div>
          <div className="pt-4">
            <NioButton href="#" img="/images/icon/a.png" label="Sign Up with Google" className="border border-lighter text-nowrap text-dark w-100 " />
          </div> */}
        </NioCard.Body>
      </NioCard>
      <ToastContainer position="top-left"/>
    </AuthLayout >
  )
}
